import { io } from 'socket.io-client';
import { DEFAULT_SOCKET_OPTS } from '../const';
export class BaseClient {
    wssHost;
    wssPath;
    // 记录已注册的事件 => 避免重复注册相同事件的监听器
    eventRecord = new Map();
    socketInstance;
    constructor(_host, _path) {
        this.wssHost = _host;
        this.wssPath = _path;
    }
    get socket() {
        if (!this.socketInstance) {
            this.socketInstance = io(this.wssHost, this.clientOpts());
            this.onSocketInit(this.socketInstance);
        }
        return this.socketInstance;
    }
    clientOpts() {
        const path = this.wssPath;
        return {
            ...DEFAULT_SOCKET_OPTS,
            ...(path ? { path } : {}),
        };
    }
    onSocketInit(_socket) { }
    disconnectClient() {
        if (!this.socketInstance) {
            return;
        }
        this.socketInstance.disconnect();
        this.socketInstance.removeAllListeners();
        this.eventRecord.forEach(_eventSet => _eventSet.clear());
        this.eventRecord.clear();
        this.socketInstance = undefined;
    }
    on(key, eventName, listener) {
        if (!key || !eventName || !listener) {
            return false;
        }
        let eventSet = this.eventRecord.get(key);
        if (!eventSet) {
            eventSet = new Set();
            this.eventRecord.set(key, eventSet);
        }
        if (eventSet.has(eventName)) {
            return false;
        }
        eventSet.add(eventName);
        const { socket } = this;
        socket.on(eventName, listener);
        return true;
    }
    onConnect(key, listener) {
        this.on(key, 'connect', listener);
        if (this.socket.connected) {
            listener();
        }
    }
}
